import { useState } from "react";

const useCreateClientSet = ({ createClientSet, onHide }) => {
    const [name, setName] = useState("");

    const onCancelClick = () => {
        setName("");
        onHide();
    }

    const onCreateClick = () => {
        createClientSet(name);
        onCancelClick();
    }

    return {
        name,
        setName,
        onCancelClick,
        onCreateClick
    };
}

export default useCreateClientSet;